
const state = function () {
  return {
    migratingInstructor: false,
    selectedMigrateInsturctor: null,
    migrateOpen: false,
    savingUser: false,
    loadingData: false,
    userClassesLoading: false,
    affiliateManagersLoading: false,
    affiliateManagers: [],
    selectedAffiliateManagers: [],
    managerAffiliateModalOpen: false,
    currentManagerAffiliateManager: null,
    addingManagerToAffiliate: false,
    managerAffiliates: [],
    managerAffiliatesLoading: false,
    affiliateManagerModalOpen: false,
    selectedManagerAffiliates: [],
    addingAffiliateToManager: false,
    list: [],
    selectedUser: {},
    activeSearchType: 'all',
    searchType: 'all',
    userPagination: {
      rowsNumber: 0,
      rowsPerPage: 10,
      page: 1,
      descending: true,
      sortBy: 'DATE_CREATED'
    },
    searchFields: {
      all: {
        USER_FIRST_NAME: null,
        USER_LAST_NAME: null,
        ACTIVE_IND: null,
        USER_PHONE: null,
        USER_EMAIL: null
      },
      instructors: {
        'INSTRUCTOR.INSTRUCTOR_CODE': null,
        USER_FIRST_NAME: null,
        USER_LAST_NAME: null,
        'INSTRUCTOR.ACTIVE_IND': null,
        'INSTRUCTOR.AFFILIATES.AFFILIATE.AFFILIATE_CODE': null,
        USER_PHONE: null,
        APPROVED_DATE_START: null,
        APPROVED_DATE_END: null
      },
      affiliates: {
        'AFFILIATE.AFFILIATE_CODE': null,
        'AFFILIATE.AFFILIATE_NAME': null,
        'AFFILIATE.AFFILIATE_NAME': null,
        ACTIVE_IND: null,
        'RECRUITER_CODE': null,
        'AFFILIATE.STUDENT_PROCESSING_FEE': null,
        USER_PHONE: null,
        APPROVED_DATE_START: null,
        APPROVED_DATE_END: null
      },
      administrators: {
        USER_FIRST_NAME: null,
        USER_LAST_NAME: null,
        ACTIVE_IND: null,
        USER_PHONE: null,
        USER_EMAIL: null
      },
      recruiters: {
        'RECRUITER.AFFILIATES.AFFILIATE_CODE': null,
        'RECRUITER.AFFILIATES.AFFILIATE_NAME': null,
        ACTIVE_IND: null,
        'RECRUITER.RECRUITER_CODE': null,
        'RECRUITER.RECRUITER_FEE': null,
        USER_PHONE: null,
        APPROVED_DATE_START: null,
        APPROVED_DATE_END: null
      },
      managers: {
        USER_FIRST_NAME: null,
        USER_LAST_NAME: null,        
        APPROVED_DATE_START: null,
        APPROVED_DATE_END: null        
      }
    },
    // Change the Columns based on Search Type
    userSearchColumns: {
      all: ['USER_FIRST_NAME', 'USER_LAST_NAME', 'USER_DOB', 'USER_PHONE', 'USER_EMAIL', 'ACTIVE_IND'],
      administrators: ['USER_FIRST_NAME', 'USER_LAST_NAME', 'USER_EMAIL', 'ACTIVE_IND'],
      managers: ['USER_FIRST_NAME', 'USER_LAST_NAME', 'USER_EMAIL', 'ACTIVE_IND'],
      affiliates: ['AFFILIATE_NAME', 'AFFILIATE_CODE', 'AFFILIATE_PROCESSING', 'USER_FIRST_NAME', 'USER_LAST_NAME', 'AFFILIATE_ACTIVE_IND'],
      instructors: ['INSTRUCTOR_CODE', 'USER_FIRST_NAME', 'USER_LAST_NAME', 'INSTRUCTOR_ACTIVE_IND', 'INSTRUCTOR_ASSOCIATED_AFFILIATES'],
      recruiters: ['RECRUITER_CODE', 'USER_FIRST_NAME', 'USER_LAST_NAME', 'USER_PHONE', 'USER_EMAIL', 'RECRUITER_ACTIVE_IND'],
    },
    userModal: {
      open: false,
      maximized: false,
      selectedTab: 'general',
      mode: '',
      canEdit: true
    },
    userWizardModal: {
      open: false,
      maximized: false,
      invalidUserRoles: false,
      selectedTab: 'general',
      mode: ''
    },
    roles: [
      { label: 'Instructor', field: "INSTRUCTOR", value: false },
      { label: 'Recruiter', field: "RECRUITER", value: false },
      { label: 'Affiliate', field: "AFFILIATE", value: false },
      { label: 'Manager', field: "MANAGER", value: false },
      { label: 'Administrator', field: "ADMINISTRATOR", value: false }
    ],
    activeApproval: {
      INSTRUCTOR_ID: null,
      STATUS: '',
      NOTES: '',
      history: []
    },
    autoCompleteList: [],
    managerAutoCompleteList: [],
    affiliateAutoCompleteList: [],
    instructorList: [],
    instructorClassList: [],
    affiliateList: [],
    recruiterList: [],
    managerList: [],
    managerCourses: [],
    userForm: {
      USER_ID: null,
      USER_ADDRESS_ID: null,
      USER_FIRST_NAME: null,
      USER_MIDDLE_NAME: null,
      USER_LAST_NAME: null,
      USER_SUFFIX: null,
      CUSTOMER_ID: null,
      // USER_SSN_A: null,
      // USER_SSN_B: null,
      USER_DOB: null,
      USER_GENDER: null,
      USER_EMAIL: null,
      USER_PHONE: null,
      USER_PHONE_EXT: null,
      USER_NOTES: null,
      LK_USER_STATUS_ID: null,
      ACTIVE_IND: false,
      DATE_LAST_LOGIN: null
    },
    billingForm: {
      loading: false,
      paymentProfiles: []
    },
    billingAddressForm: {
      ADDRESS_ID: null,
      ADDRESS_1: '',
      ADDRESS_2: '',
      CITY: '',
      COUNTY: '',
      LK_STATE_ID: '',
      ZIP_CODE: '',
      ACTIVE_IND: false
    },
    shippingAddressForm: {
      sameAsBilling: false,
      ADDRESS_ID: null,
      ADDRESS_1: '',
      ADDRESS_2: '',
      CITY: '',
      COUNTY: '',
      LK_STATE_ID: '',
      ZIP_CODE: '',
      ACTIVE_IND: false
    },
    instructorForm: {
      INSTRUCTOR_ID: null,
      DRIVERS_LICENSE: '',
      DRIVERS_LICENSE_STATE: null,
      INSTRUCTOR_CODE: '',
      SOCIAL_SECURITY_NUMBER: '',
      APPROVAL_STATUS: 1,
      APPROVAL_DATE: '',
      RECERTIFICATION_DATE: '',
      ACTIVE_IND: false,
      INSTRUCTOR_AFFILIATES: []
    },
    recruiterForm: {
      MANAGER_ID: null,
      RECRUITER_ID: null,
      USER_ID: null,
      AFFILIATES: [],
      RECRUITER_CODE: '',
      ACTIVE_IND: false
    },
    affiliateForm: {
      AFFILIATE_ID: null,
      DRIVERS_LICENSE: '',
      DRIVERS_LICENSE_STATE: null,
      SCHOOL_NAME: '',
      SCHOOL_CODE: '',
      SOCIAL_SECURITY_NUMBER: '',
      STUDENT_PROCESSING_FEE: null,
      RECRUITER_FEE: null,
      FEDERAL_EMPLOYER_IDENTIFICATION_NUMBER: '',
      AVAILABLE_CREDITS: 0.00,
      BOOK_FEE: null,
      APPROVAL_DATE: '',
      ACTIVE_IND: false,
      PRINT_PERMISSON: 0,
      SCHOOL_ENTERED: 0,
      COURSES: []
    },
    managerForm: {
      MANAGER_ID: null,
      ACTIVE_IND: false,
      COURSES: []
    },
    administratorForm: {
      ADMINISTRATOR_ID: null,
      ACTIVE_IND: false
    },
    /**
     * TODO: need to refactor this one day. Permissions should be checked on api, not stored here.
     */
    notificationSettings:{
      USER_NOTIFICATION_SETTINGS_ID: null,
      items:[
      {
        key: "ROSTER_READY",
        description:"Your roster is ready",
        group: "Jobs",
        permissions: [['ADMIN'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "CLASS_CREATED",
        description:"Class is created",
        group: "Approvals",
        permissions: [['ADMIN','MANAGER','AFFILIATE'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "CLASS_SUBMISSION",
        description:"Class is submitted",
        group: "Approvals",
        permissions: [['ADMIN','MANAGER','AFFILIATE'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "CLASS_APPROVED",
        description:"Class is approved",
        group: "Approvals",
        permissions:[['ADMIN','MANAGER','AFFILIATE'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "CLASS_REJECTED",
        description:"Class is rejected",
        group: "Approvals",
        permissions: [['ADMIN','MANAGER','AFFILIATE'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "INSTRUCTOR_APPROVED",
        description:"Instructor is approved",
        group: "Approvals",
        permissions: [['ADMIN','MANAGER','AFFILIATE'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "INSTRUCTOR_REJECTED",
        description:"Instructor is rejected",
        group: "Approvals",
        permissions: [['ADMIN','MANAGER','AFFILIATE'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "ORDER_PLACED",
        description:"An Order has been placed",
        group: "Orders",
        permissions: [['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR', 'RECRUITER'],'or'],
        inapp:true,
        email:true
      },
      {
        key: "ORDER_COMPLETED",
        description:"Order is completed",
        group: "Orders",
        permissions:[['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR', 'RECRUITER'],'or'],
        inapp: true,
        email: true
      },
      {
        key: "UPLOAD_DOCUMENT",
        description:"Document has been uploaded",
        group: "Documents",
        permissions: [['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or'],
        inapp: true,
        email: true
      },
      {
        key: "STUDENT_SIGNUP",
        description:"Student Signs up via Student Sign up",
        group: "Approvals",
        permissions: [['ADMIN','MANAGER','AFFILIATE','INSTRUCTOR'],'or'],
        inapp: true,
        email: true
      },
      {
        key: "UPDATE_USER",
        description:"User is updated",
        group: "Users",
        permissions: [['ADMIN','MANAGER','RECRUITER','INSTRUCTOR','AFFILIATE'],'or'],
        inapp: true,
        email: true
      }
    ]}

  }
}

export default {
  ...state()
}

export const initialState = state()
